import './App.css';
import Banner from './components/UI/Banner/Banner';

function App() {
  return (
    <div className="App">
      <Banner/>
    </div>
  );
}

export default App;
